export default {
  hero: {
    title: 'About Global Data',
    subtitle: 'Innovative Technology, Empowering the Future'
  },
  
  companyIntro: {
    title: 'Company Profile',
    paragraph1: 'Global Data is a leading provider of IT infrastructure services in the Asia-Pacific region. Leveraging deep local market insights and a global technology perspective, we lay a solid foundation for enterprises undergoing digital transformation. Over the past two decades, we have consistently delivered efficient, secure, and reliable services to numerous world-renowned companies.',
    paragraph2: 'Our service network covers major commercial centers across the Asia-Pacific region. Through the combination of localized teams and global resources, we provide seamless technology solutions for multinational enterprises and local institutions. From infrastructure planning to implementation and maintenance, Global Data accompanies customers throughout their digital transformation journey.'
  },
  
  missionVision: {
    title: 'Our Mission & Vision',
    mission: {
      title: 'Mission',
      content: 'To empower enterprise digital transformation, improve operational efficiency, and drive sustainable business growth through innovative technology and quality services.'
    },
    vision: {
      title: 'Vision',
      content: 'To become a trusted partner in the IT infrastructure management field in the Asia-Pacific region, and help customers achieve synergy between infrastructure modernization and business growth through technological innovation and service upgrading.'
    }
  },
  
  certifications: {
    title: 'Qualifications & Certifications',
    items: {
      iso9001: {
        name: 'ISO 9001',
        description: 'Quality Management System Certification'
      },
      iso27001: {
        name: 'ISO 27001',
        description: 'Information Security Management Certification'
      },
      idcIsp: {
        name: 'IDC/ISP',
        description: 'Mainland China Data Center Qualifications'
      },
      imda: {
        name: 'IMDA',
        description: 'Singapore IMDA Certification'
      },
      microsoft: {
        name: 'Microsoft Partner',
        description: 'Gold Certified Partner'
      },
      aws: {
        name: 'AWS Partner',
        description: 'Advanced Consulting Partner'
      },
      huawei: {
        name: 'Huawei Cloud Partner',
        description: 'Solution Partner'
      },
      award: {
        name: 'Industry Excellence Award',
        description: 'Asia-Pacific IT Service Innovation Award'
      }
    }
  },
  
  serviceNetwork: {
    title: 'Asia-Pacific Service Network',
    subtitle: 'Covering 11 Asia-Pacific service regions in sync with the homepage service map, providing localized IT infrastructure services and regional delivery coordination',
    serviceScopeLabel: 'Service Scope',
    regions: {
      china: {
        name: 'Mainland China',
        subtitle: 'Mainland China Service Center',
        offices: {
          shanghai: {
            title: 'Shanghai Service Center',
            address: 'Room 1003-1, Guangming Real Estate Building, No. 199 Xizang North Road, Jing\'an District, Shanghai, China'
          },
          beijing: {
            title: 'Beijing Service Center',
            address: 'No. 18, Jingjia Road, Yanqi Town, Huairou District, Beijing, China'
          },
          guangzhou: {
            title: 'Shenzhen Service Center',
            address: 'Unit 55, Room 1407, Building B, Phase 1, Tian\'an Innovation Technology Plaza, No. 4 Tairan Road, Futian District, Shenzhen, China'
          }
        },
        serviceScope: 'Mainland China, providing data center construction and operation, cloud computing solutions, network security services, and IT consulting services'
      },
      hongkong: {
        name: 'Hong Kong',
        subtitle: 'Hong Kong Service Center',
        offices: {
          hq: {
            title: 'Hong Kong Service Center',
            address: 'Room A, 1/F., Arthur Commercial Building, 33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong'
          }
        },
        serviceScope: 'Hong Kong and international business transit hub, providing cross-border data center connections, international network services, and fintech solutions',
        highlight: {
          title: 'International Business Advantage',
          content: 'As a bridge connecting mainland China and global markets, providing low-latency cross-border data transmission and international compliance consulting services'
        }
      },
      taiwan: {
        name: 'Taipei',
        subtitle: 'Taipei Service Center',
        offices: {
          taipei: {
            title: 'Taipei Service Center',
            address: ''
          },
          hsinchu: {
            title: 'Hsinchu Service Center',
            address: ''
          }
        },
        serviceScope: 'Taiwan region, focusing on high-tech manufacturing IT solutions, cloud computing services, and data security management'
      },
      japan: {
        name: 'Japan',
        subtitle: 'Japan Service Center',
        offices: {
          tokyo: {
            title: 'Tokyo Service Center',
            address: '208, 2-9-17 HIGASHITABATA, KITA-KU, TOKYO 114-0013, JAPAN'
          },
          osaka: {
            title: 'Osaka Service Center',
            address: ''
          }
        },
        serviceScope: 'Japan nationwide, providing enterprise IT infrastructure management, cloud migration, and Japanese localized technical support services'
      },
      korea: {
        name: 'South Korea',
        subtitle: 'Seoul Service Center',
        offices: {
          seoul: {
            title: 'Seoul Service Center',
            address: ''
          }
        },
        serviceScope: 'South Korea and surrounding regions, focusing on enterprise cloud transformation, data center modernization, and Korean technical support services',
        highlight: {
          title: 'Technical Expertise',
          content: 'Rich experience and expertise in IT solutions for the semiconductor and electronics manufacturing industries'
        }
      },
      singapore: {
        name: 'Singapore',
        subtitle: 'Singapore Service Center',
        offices: {
          hq: {
            title: 'Singapore Service Center',
            address: '10 ANSON ROAD #27-18 INTERNATIONAL PLAZA SINGAPORE (079903)'
          }
        },
        serviceScope: 'Singapore and surrounding Southeast Asian regions, providing regional IT infrastructure management, cloud services, and cross-border data compliance solutions',
        highlight: {
          title: 'Regional Advantage',
          content: 'As a Southeast Asian business hub, providing multilingual support and IT solutions compliant with ASEAN data protection regulations'
        }
      }
    }
  },
  
  cta: {
    title: 'Experience Our Products Now',
    description: 'Global Data is committed to providing you with cutting-edge technology solutions. Our products have helped hundreds of enterprises achieve digital transformation, improve operational efficiency, and drive business growth.',
    button: 'Contact Us'
  }
}
